export class ProductionLineBriefInputError extends Error {
    field;
    constructor(field) {
        super(`Invalid production line brief field: ${field}`);
        this.field = field;
        this.name = 'ProductionLineBriefInputError';
    }
}
/** Length limits match storage; no topical, originality or engagement gate. */
export function parseProductionLineBriefFields(raw) {
    if (typeof raw !== 'object' || raw === null || Array.isArray(raw)) {
        throw new ProductionLineBriefInputError('body');
    }
    const input = raw;
    for (const key of Object.keys(input)) {
        if (!['about', 'instructions', 'title', 'outputLocale'].includes(key)) {
            throw new ProductionLineBriefInputError(key);
        }
    }
    const text = (key, maximum, optional = false) => {
        const value = input[key];
        if (optional && (value === null || value === undefined))
            return null;
        if (typeof value !== 'string')
            throw new ProductionLineBriefInputError(key);
        const trimmed = value.trim();
        if (Array.from(trimmed).length > maximum || (!optional && trimmed.length === 0)) {
            throw new ProductionLineBriefInputError(key);
        }
        return trimmed || null;
    };
    const about = text('about', 2000);
    if (about === null)
        throw new ProductionLineBriefInputError('about');
    const instructions = text('instructions', 4000, true);
    const title = text('title', 300, true) ?? Array.from(about).slice(0, 300).join('');
    if (input['outputLocale'] !== 'en' && input['outputLocale'] !== 'ar') {
        throw new ProductionLineBriefInputError('outputLocale');
    }
    return { about, instructions, title, outputLocale: input['outputLocale'] };
}
//# sourceMappingURL=production-line-brief.js.map